/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Error Page
*/

module.exports = {
  /* 00. Generados por KC */
  "home.leaderboard": "Ranking de jugadores",

  /* 01.General */
  "general.copyright": "KingConf © Todos los derechos reservados.",
  "general.loading": "Por favor espere mientras cargamos...",

  /* 02.Inicio de sesión de usuario, cierre de sesión, registro */
  "user.login-title": "Iniciar sesión",
  "user.sign-out": "Cerrar sesión",
  "user.register": "Registro",
  "user.forgot-password": "Se te olvidó tu contraseña",
  "user.email": "Email",
  "user.password": "Contraseña",
  "user.forgot-password-question": "¿Olvidaste tu contraseña?",
  "user.fullname": "Nombre completo",
  "user.login-button": "INICIAR SESIÓN",
  "user.register-button": "REGISTRO",
  "user.reset-password-button": "REINICIAR",
  "user.buy": "COMPRAR",
  "user.username": "Nombre de Usuario",
  "user.profile": "Perfil",
  "user.certificate": "Certificado",
  "user.accessCode": "Código de acceso",
  "user.company": "Compañía",
  "user.earnedPoints": "Puntos ganados",
  "user.update": "Actualizar",
  "user.role": "Cargo",
  "user.website": "Página web",
  "user.about": "Acerca",

  /* 03.Menú */
  "menu.app": "Inicio",
  "menu.home": "Inicio",
  "menu.attendees": "Asistentes",
  "menu.dashboards": "Tableros",
  "menu.programme": "Programa",
  "menu.speakers": "Ponentes",
  "menu.makemeeting": "Agendar Reunión",
  "menu.mymeetings": "Mis Reuniones",
  "menu.sponsors": "Sponsors",
  "menu.forum": "Foros",
  "menu.liveStream": "Vivo",
  "menu.start": "Comienzo",
  "menu.second-menu": "Segundo menú",
  "menu.second": "Segundo",
  "menu.ui": "IU",
  "menu.charts": "Gráficos",
  "menu.chat": "Chatea",
  "menu.survey": "Encuesta",
  "menu.todo": "Notas",
  "menu.search": "Búsqueda",
  "menu.docs": "Docs",
  "menu.blank-page": "Blank Page",
  "menu.fair": "Exposición",
  "menu.brounds": "Rondas de Negocio",

  /* 04.Error  */
  "layouts.error-title": "Vaya, parece que ha ocurrido un error!",
  "layouts.error-code": "Código de error",
  "layouts.go-back-home": "REGRESAR A INICIO",
  "bsrounds.mediaErrors": "Se produjo el siguiente error: ",

  /* 03.Menú */
  "menu.default": "Defecto",
  "menu.analytics": "Analítica",
  "menu.ecommerce": "Comercio electrónico",
  "menu.content": "Contenido",
  "menu.pages": "Páginas",
  "menu.data-list": "Lista Datos",
  "menu.thumb-list": "Lista Miniaturas",
  "menu.image-list": "Lista Imagen",
  "menu.details": "Detalles",
  "menu.login": "Iniciar sesión",
  "menu.register": "Registro",
  "menu.forgot-password": "Olvidé mi contraseña",
  "menu.reset-password": "Reset Password",
  "menu.error": "Error",
  "menu.applications": "Aplicaciones",
  "menu.alerts": "Alertas",
  "menu.badges": "Insignias",
  "menu.buttons": "Botones",
  "menu.cards": "Tarjetas",
  "menu.carousel": "Carrusel",
  "menu.collapse": "Colapsar",
  "menu.dropdowns": "Menús Desplegables",
  "menu.editors": "Editores",
  "menu.form-layouts": "Diseños de Formulario",
  "menu.form-components": "Componentes de Formulario",
  "menu.form-validations": "Validaciones de Formulario",
  "menu.form-wizard": "Asistente de Formulario",
  "menu.icons": "Iconos",
  "menu.input-groups": "Grupos de Entrada",
  "menu.jumbotron": "Jumbotron",
  "menu.modal": "Modal",
  "menu.navigation": "Navegación",
  "menu.popover-tooltip": "Tooltips y Popovers",
  "menu.sortable": "Ordenable",
  "menu.tables": "Tablas",
  "menu.menu": "Menú",
  "menu.subhidden": "Sub Oculto",
  "menu.hidden": "Oculto",
  "menu.visible": "Visible",
  "menu.maps": "Mapas",
  "menu.landingpage": "Página de Destino",
  "menu.multipage-home": "Múltiple Página",
  "menu.singlepage-home": "Una Página",
  "menu.about": "Acerca de",
  "menu.auth-login": "Autenticación",
  "menu.auth-register": "Registro",
  "menu.blog": "Blog",
  "menu.blog-list": "Listado del Blog",
  "menu.blog-detail": "Detalle del Blog",
  "menu.careers": "Carrera",
  "menu.confirmation": "Confirmación",
  "menu.contact": "Contacto",
  "menu.features": "Caracteristicas",
  "menu.prices": "Precios",
  "menu.videos": "Videos",
  "menu.mailing": "Correo",
  "menu.invoice": "Factura",
  "menu.types": "Menu Types",
  "menu.levels": "Menu Levels",
  "menu.third-level-1": "Tercer Nivel 1",
  "menu.third-level-2": "Tercer Nivel 2",
  "menu.third-level-3": "Tercer Nivel 3",
  "menu.faq": "Pmf",
  "menu.knowledge-base": "Base de Conocimientos",
  "menu.authorization": "Autorización",
  "menu.profile": "Perfil",
  "menu.product": "Producto",
  "menu.miscellaneous": "Misceláneo",
  "menu.portfolio": "Portafolio",
  "menu.social": "Social",
  "menu.details-alt": "Details Alt",
  "menu.forms": "Formulario",
  "menu.components": "Componentes",
  "menu.layouts": "Diseños",
  "menu.validations": "Validaciones",
  "menu.wizard": "Wizard",
  "menu.posters": "Posters",
  "menu.attendee-list": "Asistentes",
  "menu.forums": "Foros",

  /* 04.Tableros */
  "dashboards.event-information": "Información del evento",
  "dashboards.sponsors-home": "Nuestros sponsors son",
  "dashboards.live-stream": "Streaming en Vivo",
  "dashboards.event-wall": "Muro del evento",
  "dashboards.zoom-meeting-home": "Información de acceso",
  "dashboards.sponsors-next-event": "Próximo evento",
  "dashboards.event-wall-add-image": "Agregar una imagen..",
  "dashboards.event-wall-search": "Buscar",
  "dashboards.write-something": "Escribe algo...",
  "dashboards.event-wall-post": "Postear",
  "dashboards.event-wall-no-more-posts": "¡Ya viste todos los posts!",
  "dashboards.event-wall-report": "Reportar",
  "dashboards.event-wall-report-confirm": "Confirmar",
  "dashboards.event-wall-report-text": "¿Estas seguro que queres reportarlo?",
  "dashboards.comment-live": "Comentá en vivo",
  "dashboards.leave-question": "Haz una pregunta",
  "dashboards.event-wall-comment": "Comentar",
  "dashboards.write-something-live": "Escribe tu comentario en vivo",
  "dashboards.schedule": "Horario",
  "dashboards.pending-orders": "Pedidos Pendientes",
  "dashboards.completed-orders": "Pedidos Completados",
  "dashboards.refund-requests": "Petición de Reembolso",
  "dashboards.new-comments": "Nuevos Comentarios",
  "dashboards.sales": "Ventas",
  "dashboards.orders": "Pedidos",
  "dashboards.refunds": "Reembolso",
  "dashboards.recent-orders": "Pedidos Recientes",
  "dashboards.product-categories": "Categorías de Producto",
  "dashboards.cakes": "Tortas",
  "dashboards.tickets": "Entradas",
  "dashboards.calendar": "Calendario",
  "dashboards.best-sellers": "Mejores Vendidos",
  "dashboards.website-visits": "Visitas al sitio web",
  "dashboards.unique-visitors": "Visitantes únicos",
  "dashboards.this-week": "Esta Semana",
  "dashboards.last-week": "La Semana Pasada",
  "dashboards.this-month": "Este Mes",
  "dashboards.conversion-rates": "Medidas de Conversión",
  "dashboards.per-session": "Por Sección",
  "dashboards.profile-status": "Estado del Perfil",
  "dashboards.payment-status": "Estado del Pago",
  "dashboards.work-progress": "Trabajo en Progreso",
  "dashboards.tasks-completed": "Tareas Completadas",
  "dashboards.payments-done": "Pagos Realizados",
  "dashboards.order-stock": "Pedidos - Valores",
  "dashboards.categories": "Categorías",
  "dashboards.quick-post": "Publicación Rápida",
  "dashboards.title": "Título",
  "dashboards.goToRoom": "Ir a salón",
  "dashboards.room": "Salón",
  "dashboards.act-track": "Tema",
  "dashboards.act-type": "Tipo",
  "dashboards.speaker-activities": "Actividades en las que participa",
  "dashboards.content": "Contenido",
  "dashboards.category": "Categoría",
  "dashboards.save-and-publish": "Guardar y Publicar",
  "dashboards.top-viewed-posts": "Publicaciones Más Vistas",
  "dashboards.posts": "Puestos",
  "dashboards.pending-for-publish": "Pendiente de Publicación",
  "dashboards.users": "Usuarios",
  "dashboards.on-approval-process": "En Proceso de Aprobación",
  "dashboards.alerts": "Alertas",
  "dashboards.waiting-for-notice": "Esperando Aviso",
  "dashboards.files": "Archivos",
  "dashboards.pending-for-print": "Pendiente para imprimir",
  "dashboards.logs": "Troncos",
  "dashboards.gogo": "GOGO",
  "dashboards.magic-is-in-the-details": "LA MAGIA ESTA EN LOS DETALLES",
  "dashboards.yes-it-is-indeed": "¡Si es verdad!",
  "dashboards.advanced-search": "Búsqueda Avanzada",
  "dashboards.toppings": "Coberturas",
  "dashboards.type": "Categoría",
  "dashboards.keyword": "Palabra Clave",
  "dashboards.search": "Búsqueda",
  "dashboards.top-rated-items": "Artículos Mejores Valorados",
  "dashboards.see-poster": "VER POSTER",
  "dashboards.close-poster": "Cerrar Poster",
  "dashboards.download-poster": "Descargar Poster",
  "dashboards.poster-heading": "Contenido",
  "dashboards.poster-expvideo": "Video Explicativo",
  "dashboards.poster-description": "Resumen",
  "dashboards.loading": "Cargando..",
  "dashboards.staticPage-more": "Ver más..",
  "dashboards.staticPage-back": "Volver",
  "dashboards.no-rooms": "No hay salones para mostrar",
  "dashboards.seeChildActs": "Ver subactividades",
  "dashboards.hideChildActs": "Ocultar subactividades",
  "dashboards.liveRoom": "LIVE",
  "dashboards.seeModal": "VER",
  "dashboards.openModalPresentation": "Presentación",
  "button.back-to-programme": "Volver al Programa",
  "dashboards.name": "Nombre",
  "dashboards.country": "País",
  "dashboards.phone": "Teléfono",
  "dashboards.company": "Compañía",
  "dashboards.sessionPartakers": "Participan en esta actividad:",
  "dashboards.noActsToShow": "No hay actividades para mostrar",
  "dashboards.trackSearch": "Buscar por Tema",
  "dashboards.typeSearch": "Buscar por Tipo",
  "dashboards.close": "Cerrar",
  "dashboards.send-message": "Enviar Mensaje",
  "dashboards.SessionNextEventCountDown-nextEventTimeRemain": "En",
  "dashboards.SessionNextEventCountDown-nextEvent": "Próximo evento en",
  "dashboards.SessionNextEventCountDown-day": "Día",
  "dashboards.SessionNextEventCountDown-days": "Días",
  "dashboards.addEventToCalendar": "Agregar a tu calendario",
  "dashboards.description-online": "Ver descripción",

  /* 05.Esquemas */
  "pages.add-new": "AGREGAR NUEVO",
  "pages.add-new-modal-title": "Agregar ítem nuevo",
  "pages.display-options": "Opciones de Pantalla",
  "pages.orderby": "Ordenar por : ",
  "pages.product-name": "Nombre del Producto",
  "pages.category": "Categoría",
  "pages.description": "Descripción",
  "pages.status": "Estado",
  "pages.cancel": "Cancelar",
  "pages.submit": "Enviar",
  "pages.delete": "Borrar",
  "pages.another-action": "Otra accion",
  "pages.actions": "ACCIONES",
  "pages.header": "Encabezado",
  "pages.details": "DETALLES",
  "pages.orders": "PEDIDOS",
  "pages.rating": "Clasificación",
  "pages.price": "Precio",
  "pages.ingredients": "Ingredients",
  "pages.is-vegan": "Es Vegano",
  "pages.order-status": "Estado del Pedido",
  "pages.bake-progress": "Progreso de Hornear",
  "pages.popularity": "Popularidad",
  "pages.comments": "Comentarios",
  "pages.error-title": "Vaya, parece que ha ocurrido un error!",
  "pages.error-code": "Código de error",
  "pages.go-back-home": "REGRESAR A INICIO",
  "pages.mailing-info":
    "Las plantillas de correo utilizan el diseño en línea y el diseño de la tabla para mostrarse bien en varios proveedores de servicios. Para proporcionar una mejor usabilidad, lo incluimos como html regular con dangerouslySetInnerHTML.",
  "pages.invoice-info":
    "La plantilla de factura tiene una versión de estilo en línea para uso fuera del proyecto, así como la versión React.",
  "pages.react-version": "React Versión",
  "pages.inline-version": "Estilo en Linea Html Versión",
  "pages.like": "Me gusta",
  "pages.likes": "Me gusta",
  "pages.details-title": "Detalles",
  "pages.comments-title": "Comentarios",
  "pages.questions-title": "Preguntas",
  "pages.similar-projects": "Proyectos Similares",
  "pages.send": "Enviar",
  "pages.addComment": "Añadir un comentario",
  "pages.location": "Ubicación",
  "pages.responsibilities": "Responsabilidades",
  "pages.photos": "Fotos",
  "pages.who-to-follow": "A quién seguir",
  "pages.follow": "SEGUIR",
  "pages.followers": "SEGUIDORES",
  "pages.recent-posts": "Mensajes Recientes",
  "pages.profile": "PERFIL",
  "pages.friends": "AMIGOS",
  "pages.images": "IMAGENES",
  "pages.purchase": "COMPRA",
  "pages.price.developer": "REVELADOR",
  "pages.price.team": "EQUIPO",
  "pages.price.enterprise": "EMPRESA",
  "pages.price.twofactorauthentication": "Autenticación de dos factores",
  "pages.price.teampermissions": "Permisos del equipo",
  "pages.price.245Support": "24/5 Soporte",
  "pages.price.247Support": "24/7 Soporte",
  "pages.price.useractionsauditlog": "Registro de acciones del usuario",
  "pages.prices.featurecomparison": "Comparación de Características",
  "pages.prices.pricecomparison": "Comparación de Precios",

  /* 06.Aplicaciones */

  /* 06.01.Chatea */
  "chat.messages": "Mensajes",
  "chat.contacts": "Contactos",
  "chat.saysomething": "Di algo..",

  /* 06.02.Encuesta */
  "survey.delete": "Borrar",
  "survey.edit": "Edit",
  "survey.add-new": "AGREGAR NUEVO",
  "survey.add-new-title": "Add New Encuesta",
  "survey.title": "Título",
  "survey.category": "Categoría",
  "survey.label": "Etiqueta",
  "survey.status": "Estado",
  "survey.cancel": "Cancelar",
  "survey.submit": "Enviar",
  "survey.another-action": "Otra accion",
  "survey.display-options": "Opciones de Pantalla",
  "survey.orderby": "Ordenar por : ",
  "survey.all-surveys": "Todas las Encuestas",
  "survey.completed-surveys": "Encuestas Completadas",
  "survey.categories": "Categorías",
  "survey.active-surveys": "Encuestas Activas",
  "survey.labels": "Etiquetas",

  /* 06.03.Notas */
  "todo.add-new": "AGREGAR NUEVO",
  "todo.add-new-title": "Añadir Nuevo",
  "todo.title": "Título",
  "todo.detail": "Detalle",
  "todo.category": "Categoría",
  "todo.label": "Etiqueta",
  "todo.status": "Estado",
  "todo.cancel": "Cancelar",
  "todo.submit": "Enviar",
  "todo.action": "Accion",
  "todo.another-action": "Otra accion",
  "todo.display-options": "Opciones de Pantalla",
  "todo.orderby": "Ordenar por : ",
  "todo.all-tasks": "Todas las Tareas",
  "todo.pending-tasks": "Tareas Pendientes",
  "todo.completed-tasks": "Tareas Completadas",
  "todo.categories": "Categorías",
  "todo.labels": "Etiquetas",

  /* 07.IU */

  /* 07.01.Alertas */
  "alert.rounded": "Alerta Redondeado",
  "alert.react-notifications": "React Notificaciones",
  "alert.outline": "Contorno",
  "alert.primary": "Primary",
  "alert.secondary": "Secondary",
  "alert.info": "Info",
  "alert.success": "Success",
  "alert.warning": "Warning",
  "alert.error": "Error",
  "alert.filled": "Lleno",
  "alert.primary-text": "¡Esto es un primary alert—check fuera!",
  "alert.secondary-text": "¡Esto es un secondary alert—check fuera!",
  "alert.success-text": "¡Esto es un success alert—check fuera!",
  "alert.danger-text": "¡Esto es un danger alert—check fuera!",
  "alert.warning-text": "¡Esto es un warning alert—check fuera!",
  "alert.info-text": "¡Esto es un info alert—check fuera!",
  "alert.light-text": "¡Esto es un light alert—check fuera!",
  "alert.dark-text": "¡Esto es un dark alert—check fuera!",
  "alert.default": "Alerta por Defecto",
  "alert.dismissing": "Despido de Alerta",
  "alert.dismissing-text":
    "¡Santo guacamole! Debes revisar algunos de esos campos a continuación.",
  "alert.dismissing-without-animate-text":
    "¡Estoy alerta y me pueden despedir sin animarme!",

  /* 07.02.Badges */
  "badge.sizes": "Tamaños",
  "badge.colors": "Colores",
  "badge.outline": "Contorno",
  "badge.links": "Enlaces",
  "badge.counter-badges": "Mostrador Badges",
  "badge.bootstrap-default": "Bootstrap Defecto",
  "badge.primary": "Primary",
  "badge.secondary": "Secondary",
  "badge.success": "Success",
  "badge.danger": "Danger",
  "badge.warning": "Warning",
  "badge.info": "Info",
  "badge.light": "Light",
  "badge.dark": "Dark",

  /* 07.03.Botones */
  "button.default": "Bootstrap Defecto",
  "button.colors": "Colores",
  "button.rounded": "Botones Redondeado",
  "button.outline": "Contorno",
  "button.states": "Estados",
  "button.sizes": "Tamaños",
  "button.button-groups": "Grupos de Botones",
  "button.large-button": "Botón Grande",
  "button.small-button": "Botón Pequeño",
  "button.extra-small-button": "Botón Extra Pequeño",
  "button.block-button": "Botón de Bloqueo",
  "button.active": "Activo",
  "button.disabled": "Discapacitado",
  "button.basic": "Básico",
  "button.toolbar": "Barra de Herramientas",
  "button.nesting": "Anidando",
  "button.vertical-variation": "Variación Vertical",
  "button.checkbox-radio-button": "Checkbox  y Radio Buttons",
  "button.checkbox": "Checkbox",
  "button.radio": "Radio",
  "button.radio-button": "Radio Button",
  "button.primary": "Primary",
  "button.secondary": "Secondary",
  "button.success": "Success",
  "button.danger": "Danger",
  "button.warning": "Warning",
  "button.info": "Info",
  "button.light": "Light",
  "button.dark": "Dark",
  "button.states-text":
    "Este botón muestra una rueda giratoria durante 2 segundos y un icono de error durante 3 segundos antes de cambiar al estado normal. Estos estados se pueden activar agregando y eliminando clases.",
  "button.click-here": "Haga clic aquí",
  "button.states-text-alternate":
    "Este botón muestra una rueda giratoria durante 2 segundos y un icono de error durante 3 segundos antes de cambiar al estado normal. Estos estados se pueden activar agregando y eliminando clases.",
  "button.primary-link": "Primary Enlace",
  "button.link": "Enlace",
  "button.primary-button": "Primary Botón",
  "button.button": "Botón",
  "button.left": "Izquierda",
  "button.middle": "Centro",
  "button.right": "Derecha",
  "button.dropdown": "Desplegable",
  "button.dropdown-link": "Enlace Desplegable",
  /* Botones extra KingConf */
  buttons: {
    send: "Enviar",
    close: "Cerrar",
    accept: "Aceptar",
    cancel: "Cancelar"
  },
  "button.send": "Enviar",
  "button.close": "Cerrar",
  "button.accept": "Aceptar",
  "button.cancel": "Cancelar",
  /* Botones extra KingConf */
  /* 07.04.Tarjetas */
  "cards.icon-card": "Tarjeta de Icono",
  "cards.image-card": "Tarjeta de Imagen",
  "cards.image-overlay-card": "Tarjeta de Superposición de Imágenes",
  "cards.image-card-list": "Lista de Tarjetas de Imagen",
  "cards.tab-card": "Tarjeta de Tab",
  "cards.user-card": "Tarjeta de Usuario",
  "cards.sponsor-card-name": "Nombre",
  "cards.sponsor-card-desc": "Descripción",
  "cards.sponsor-card-locat": "Lugar",
  "cards.sponsor-card-contact": "Contacto",

  /* 07.05.Carrusel */
  "carousel.basic": "Carrusel Básico",
  "carousel.single": "Carrusel Sólo",
  "carousel.without-controls": "Carrusel sin Control",

  /* 07.06.Gráficos */
  "charts.line": "Gráfico de Linea",
  "charts.polar": "Gráfico de Polar",
  "charts.area": "Gráfico de Área",
  "charts.scatter": "Gráfico de Dispersión",
  "charts.bar": "Gráfico de Barras",
  "charts.radar": "Gráfico de Radar",
  "charts.pie": "Gráfico de Circular",
  "charts.doughnut": "Gráfico de Rosquilla",
  "charts.shadow": "Sombra",
  "charts.no-shadow": "Sin Sombra",

  /* 07.07.Colapso */
  "collapse.basic": "Básico",
  "collapse.toggle": "Palanca",
  "collapse.accordion": "Acordeón",
  "collapse.controlled": "Revisado",
  "collapse.uncontrolled": "Sin Control",

  /* 07.08.Desplegables */
  "dropdowns.basic": "Básico",
  "dropdowns.controlled": "Revisado",
  "dropdowns.uncontrolled": "Sin Control",
  "dropdowns.dropdown": "Desplegable",
  "dropdowns.header": "Encabezado",
  "dropdowns.action": "Accion",
  "dropdowns.another-action": "Otra accion",
  "dropdowns.right": "Derecha",
  "dropdowns.left": "Izquierda",
  "dropdowns.drop-directions": "Direcciones de drop",
  "dropdowns.dropright": "Drop Derecha",
  "dropdowns.dropleft": "Drop Izquierda",
  "dropdowns.small-button": "Botón Pequeño",
  "dropdowns.large-button": "Botón Grande",
  "dropdowns.sizing": "Dimensionamiento",
  "dropdowns.split-button": "Botones Desplegables",
  "dropdowns.dropup": "Dropup",

  /* 07.09.Editores */
  "editors.draftjs": "Draft.js",
  "editors.quill-standart": "Quill Estándar",
  "editors.quill-bubble": "Quill Burbuja",

  /* 07.10.Formularios */
  "forms.basic": "Básico",
  "forms.email": "Email",
  "forms.email-muted": "Nunca compartiremos tu email con nadie más.",
  "forms.password": "Contraseña",
  "forms.password-confirm": "Confirmar Contraseña",
  "forms.submit": "Enviar",
  "forms.horizontal": "Horizontal",
  "forms.radios": "Radios",
  "forms.first-radio": "Primero radio",
  "forms.second-radio": "Segundo radio",
  "forms.third-radio-disabled": "Tercera radio deshabilitada",
  "forms.checkbox": "Checkbox",
  "forms.signin": "Registrarse",
  "forms.top-labels-over-line": "Etiquetas Superiores Sobre la Línea",
  "forms.tags": "Etiquetas",
  "forms.date": "Fecha",
  "forms.state": "Estado",
  "forms.top-labels-in-input": "Etiquetas Superiores Sobre la Entrada",
  "forms.email-u": "EMAIL",
  "forms.password-u": "CONTRASEÑA",
  "forms.tags-u": "ETIQUETAS",
  "forms.date-u": "FECHA",
  "forms.state-u": "ESTADO",
  "forms.grid": "Cuadrícula de Formulario",
  "forms.address": "Dirección",
  "forms.address2": "Dirección 2",
  "forms.city": "Ciudad",
  "forms.city-message": "Por favor seleccione una ciudad!",
  "forms.state-message": "Por favor seleccione un estado!",
  "forms.zip": "Código Postal",
  "forms.signup": "Regístrate",
  "forms.inline": "Inline",
  "forms.validation": "Validación",
  "forms.default": "Defecto",
  "forms.firstname": "Nombre de Pila",
  "forms.firstname-message": "¡Por favor, introduzca su nombre de pila!",
  "forms.lastname": "Apellido",
  "forms.lastname-message": "¡Por favor ingrese su apellido!",
  "forms.name": "Nombre",
  "forms.validation-availity": "Availity Reactstrap Validation",
  "forms.validation-formik": "Formik Validation",

  /* 07.11.Componentes */
  "form-components.custom-inputs": "Entrada Personalizada",
  "form-components.checkboxes": "Checkboxes",
  "form-components.radios": "Radios",
  "form-components.inline": "Inline",
  "form-components.react-select": "React Select",
  "form-components.state-single": "Estado Soltero",
  "form-components.state-multiple": "Estado Múltiple",
  "form-components.react-autosuggest": "React Autosuggest",
  "form-components.date-picker": "Selector de Fechas",
  "form-components.date": "Fecha",
  "form-components.date-range": "Rango de Fechas",
  "form-components.date-with-time": "Fecha con Hora",
  "form-components.embedded": "Incrustado",
  "form-components.dropzone": "Dropzone",
  "form-components.drop-files-here": "Soltar Archivos Aquí",
  "form-components.tags": "Etiquetas",
  "form-components.switch": "Cambiar",
  "form-components.primary": "Primary",
  "form-components.secondary": "Secondary",
  "form-components.primary-inverse": "Primary Inverso",
  "form-components.secondary-inverse": "Secondary Inverso",
  "form-components.slider": "Deslizador",
  "form-components.double-slider": "Doble Deslizador",
  "form-components.single-slider": "Único Deslizador",
  "form-components.rating": "Clasificación",
  "form-components.interactive": "Interactivo",
  "form-components.readonly": "Solo Lectura",
  "form-components.type-a-cake": "Escribe un pastel",
  "form-components.start": "Comienzo",
  "form-components.end": "Fin",
  "form-components.tables": "Tablas",
  /* 07.12.Iconos */
  "icons.simplelineicons": "Simple Line Iconos",
  "icons.iconsmind": "Iconsmind Iconos",

  /* 07.13.Grupos de Entrada */
  "input-groups.basic": "Básico",
  "input-groups.sizing": "Dimensionamiento",
  "input-groups.small": "Pequeño",
  "input-groups.default": "Defecto",
  "input-groups.large": "Grande",
  "input-groups.checkboxes-and-radios": "Checkboxes y radios",
  "input-groups.multiple-inputs": "Entradas Múltiples",
  "input-groups.first-and-last-name": "Nombre y apellido",
  "input-groups.multiple-addons": "Complementos Múltiples",
  "input-groups.button-addons": "Complementos Botón",
  "input-groups.button": "Botón",
  "input-groups.buttons-with-dropdowns": "Botones y Desplegables",
  "input-groups.dropdown": "Desplegable",
  "input-groups.header": "Encabezado",
  "input-groups.action": "Accion",
  "input-groups.another-action": "Otra accion",
  "input-groups.custom-select": "Personalizada Select",
  "input-groups.options": "Opciones",
  "input-groups.choose": "Escoger...",
  "input-groups.custom-file-input": "Entrada de Archivo Personalizada",

  /* 07.14.Jumbotron */
  "jumbotron.hello-world": "¡Hola Mundo!",
  "jumbotron.lead":
    "Esta es una unidad de héroe simple, un componente de estilo jumbotron simple para llamar la atención extra al contenido o información destacados.",
  "jumbotron.lead-detail":
    "Utiliza clases de utilidad para tipografía y espaciado para espaciar el contenido dentro del contenedor más grande.",
  "jumbotron.learn-more": "Aprende más",

  /* 07.15.Modal */
  "modal.basic": "Básico",
  "modal.modal-title": "Título Modal",
  "modal.launch-demo-modal": "Lanzar Demo Modal",
  "modal.scrolling-long-content": "Contenido de Desplazamiento Largo",
  "modal.backdrop": "Fondo",
  "modal.backdrop-value": "Valor de Fondo",
  "modal.right-modal": "Derecha Modal",
  "modal.launch-right-modal": "Launch Derecha Modal",
  "modal.nested-modal": "Modal Anidado",
  "modal.size": "Tamaño",
  "modal.launch-large-modal": "Lanzar Grande Modal",
  "modal.launch-small-modal": "Lanzar Pequeño Modal",

  /* 07.16.Navegación */
  "nav.basic": "Navegación Básico",
  "nav.active": "Activo",
  "nav.disabled": "Discapacitado",
  "nav.disabled-link": "Enlace Discapacitado",
  "nav.link": "Enlace",
  "nav.longer-link": "Enlace de navegación más largo",
  "nav.another-link": "Otro Enlace",
  "nav.right": "Derecha",
  "nav.dropdown": "Desplegable",
  "nav.header": "Encabezado",
  "nav.action": "Accion",
  "nav.another-action": "Otra accion",
  "nav.horizontal-alignment": "Alineación Horizontal",
  "nav.vertical-alignment": "Alineación Vertical",
  "nav.pills": "Navegación Píldoras",
  "nav.fill-justify": "Navegación Llenar y Justify",
  "nav.pills-dropdowns": "Nav Pills with Dropdowns",
  "nav.pagination-basic": "Paginación Básico",
  "nav.pagination-sizing": "Paginación Dimensionamiento",
  "nav.large": "Grande",
  "nav.small": "Pequeño",
  "nav.center": "Centro",
  "nav.pagination-alignment": "Alineación de Paginación",
  "nav.breadcrumb-basic": "Migas de Pan Básico",

  /* 07.17.Tooltips y Popovers */
  "popover-tooltip.popover": "Popovers",
  "popover-tooltip.tooltip": "Tooltips",

  /* 07.18.Ordenable */
  "sortable.columns": "Clasificar Columnas",
  "sortable.basic": "Básico",
  "sortable.handles": "Handles",

  /* 07.19.Maps */
  "maps.google": "Google",
  "maps.yandex": "Yandex",

  /* 07.20.Tables */
  "table.bootstrap-tables": "Tablas Bootstrap",
  "table.bootstrap-basic": "Tablas Básicas",
  "table.bootstrap-striped": "Cebreadas",
  "table.bootstrap-bordered": "Tablas Con Bordes",
  "table.bootstrap-borderless": "Tablas Sin Bordes",
  "table.bootstrap-hoverable": "Tablas dinámicas",
  "table.bootstrap-responsive": "Tablas Responsive",
  "table.react-tables": "Tablas React",
  "table.react-pagination": "Paginación",
  "table.react-scrollable": "Tablas Con Voluta",
  "table.react-advanced": "Filtro, Longitud y Salto",
  "table.divided": "Divided Table",

  /* 07.21.Wizards */
  "wizard.step-name-1": "Paso 1",
  "wizard.step-name-2": "Paso 2",
  "wizard.step-name-3": "Paso 3",
  "wizard.step-desc-1": "Descripción del primer paso",
  "wizard.step-desc-2": "Descripción del segundo paso",
  "wizard.step-desc-3": "Descripción del tercer paso",
  "wizard.content-1": "Contenido para el primer paso.",
  "wizard.content-2": "Contenido para el segundo paso.",
  "wizard.content-3": "Contenido del último paso!",
  "wizard.content-thanks": "Gracias!",
  "wizard.next": "Entrante",
  "wizard.prev": "Anterior",
  "wizard.registered": "¡Su registro se completó con éxito!",
  "wizard.async": "¡Ahorro asíncrono durante 3 segundos!",

  /*NUEVOS DE KC */
  "br.my-pending-answer":
    "Tienes una solicitud de &nbsp;{name} pendiente de respuesta",
  "br.their-pending-answer":
    "Realizaste una solicitud a <b>{firstname} {lastname}</b> que está pendiente de respuesta",
  "br.their-pending-answer-mymeetings":
    "Reunión solicitada de <b>{firstname} {lastname}</b> ",
  "br.confirmed-meeting-mymeetings":
    "Tienes una reunión confirmada con <b>{firstname} {lastname}</b> ",
  "br.another-meeting":
    "Tienes una solicitud pendiente de respuesta de <b>{firstname} {lastname}</b>",
  "br.my-meeting-request-mymeetings":
    "Realizaste una solicitud a <b>{firstname} {lastname}</b> que está pendiente de respuesta",
  "br.time-slot-available": "¡Ambos están disponibles en este horario!",
  "br.requester-message": "Escribiste:",
  "br.time-slot-not-available":
    "<b>{name} </b> no se encuentra disponible en este horario",
  "br.time-slot-available-mymeetings": "¡Horario disponible!",
  "br.request-meeting": "Solicita tu reunión",
  "br.timezone-clarification":
    "* Los horarios son locales según la configuración de tu navegador GMT{time}",
  "br.meeting-clarification":
    "* Accede a la sección “Mis reuniones” para confirmar o rechazar la solicitud",
  "br.start-meeting": "Tener reunión",
  "br.accept-meeting": "Aceptar reunión",
  "br.reject-meeting": "Rechazar reunión",
  "br.meeting-stablished":
    "Tienes una reunión confirmada con <b>{firstname} {lastname}</b>",
  "br.no-slots-available": "Lo sentimos, pero no pudimos encontrar ningún horario disponible que se superponga entre tú y la persona solicitada.",
  "br.no-slots-available-today": "Lo sentimos, pero no pudimos encontrar ningún horario disponible que se superponga entre tú y la persona solicitada en el día seleccionado.",
  "br.no-participants-match": "Lamentablemente, no pudimos encontrar ningún participante que coincida con los criterios de búsqueda seleccionados.",
  "br.no-longer-available": "Lamentablemente, el horario solicitado ya no está disponible. Por favor, seleccione un horario diferente que funcione para ambas partes.",
  "br.request-succesful": "Su solicitud de reunión se ha enviado correctamente.",
  "br.error-loading-my-meetings": "Lamentablemente, no se pudo cargar el calendario. Por favor, inténtelo de nuevo más tarde o póngase en contacto con el organizador del evento para obtener ayuda.",
  "br.your-agenda": "Tu agenda",
  "br.block-slot": "Bloquear horario",
  "br.unblock-slot": "Desbloquear horario",
  "br.cancel-meeting": "Cancelar reunión",
  "br.time-slot-blocked": "Este horario fue bloqueado por ti",
  "br.leave-meeting": "Salir",
  "br.waiting-person": "Esperando que se conecte la otra persona...",
  "br.sharing-screen": "Estas compartiendo tu pantalla",
  "br.waitingForCounterpart": "Esperando al otro participante...",

  "networking.write-message": "Escribe tu mensaje aquí",
  "zoom-meeting-info": "Ingresa a la reunión de",
  "login.access-code": "Código de acceso",
  "login.submit": "Ingresar",
  "login.register": "Registrarse",
  "login.welcome-text": "BIENVENIDO A ",
  "login.not-open-yet": "El evento no se encuentra abierto al público aún",
  "login.placeholder-email": "Email de registro",
  "login.placeholder-codigo-acceso": "Código de acceso",
  "login.invalid-credentials": "Credenciales inválidas",
  "speakers.search": "Busca un orador",
  "event.finished": "El evento",
  "event.finished-2": "ha finalizado"
};